const card = "rounded-xl border bg-background border-border/60 p-3 cursor-pointer hover:bg-muted/30 transition-colors text-left w-full";

const headerRow = "flex items-center justify-between mb-2";

const statusTimeText = "text-xs text-muted-foreground flex items-center gap-1";

const errorText = "text-xs text-destructive mb-2";

const entriesList = "max-h-48 overflow-y-auto space-y-1";

const simulatedBadge = "text-[10px] px-1.5 py-0.5 rounded-full bg-warning/10 text-warning font-medium";

const clickHint = "flex items-center gap-1.5 mt-2 text-[11px] text-muted-foreground/60";

const clickHintIcon = "h-3 w-3";

const overlay = "fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4";

const modal = "bg-background rounded-lg border border-border w-full max-w-2xl max-h-[80vh] flex flex-col shadow-xl";

const modalHeader = "flex items-center justify-between p-4 border-b border-border shrink-0";

const modalTitle = "text-base font-semibold text-foreground";

const closeBtn = "p-1 rounded-md hover:bg-muted transition-colors";

const modalMeta = "flex flex-wrap items-center gap-3 px-4 py-3 border-b border-border text-xs text-muted-foreground";

const modalError = "mx-4 mt-2 text-xs text-destructive bg-destructive/10 rounded px-3 py-2";

const modalSection = "px-4 py-3 border-t border-border";

const modalSectionTitle = "text-xs font-semibold text-muted-foreground uppercase tracking-wider mb-2";

const messagesList = "max-h-64 overflow-y-auto space-y-0.5";

const noMessages = "text-xs text-muted-foreground italic py-2";

const messageItem = "text-[11px] text-foreground font-mono leading-relaxed py-0.5";

const iconSm = "h-3 w-3";

const checkIcon = "h-4 w-4 text-success";

const alertIcon = "h-4 w-4 text-destructive";

const loaderIcon = "h-4 w-4 animate-spin text-muted-foreground";

export {
  card,
  headerRow,
  statusTimeText,
  errorText,
  entriesList,
  simulatedBadge,
  clickHint,
  clickHintIcon,
  overlay,
  modal,
  modalHeader,
  modalTitle,
  closeBtn,
  modalMeta,
  modalError,
  modalSection,
  modalSectionTitle,
  messagesList,
  noMessages,
  messageItem,
  iconSm,
  checkIcon,
  alertIcon,
  loaderIcon,
};
